import React from 'react';
import {Link} from 'react-router-dom'
import './footer.css'

const Footer = () => {
  return (
    <footer>
      <Link to="/about" className="footerv3">&copy; Mussagy Remane 2022</Link>
      <a href="https://mussagyremane.netlify.app/" target="_blank" rel="noopener noreferrer" className="footerv1">Portfolio V1.0</a>
    </footer>
  );
}

export default Footer;
